// @ vendors
const { Promise } = require('es6-promise');
// @ actions
const notification = require('actions/notifications');
const signaturePatternActions = require('actions/signaturePattern');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');

const setAccountDebitEditSuccess = (accountId) => ({
    type: actionTypes.SET_ACCOUNT_DEBITS_EDIT_SUCCESS,
    payload: {
        accountId
    }
});

const setAccountDebitEditFailure = (error, accountId) => ({
    type: actionTypes.SET_ACCOUNT_DEBITS_EDIT_FAILURE,
    payload: {
        accountId,
        error
    }
});

const reset = () =>({
    type: actionTypes.ACCOUNT_DEBITS_EDIT_RESET
});

const resetStep = (step) =>({
    type: actionTypes.ACCOUNT_DEBITS_EDIT_RESET_STEP,
    payload: {
        step
    }
});

const setAccount = (account) => ({
    type: actionTypes.ACCOUNT_DEBITS_EDIT_SET_ACCOUNT,
    payload: {
        account
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.ACCOUNT_DEBITS_EDIT_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.ACCOUNT_DEBITS_EDIT_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const requestAccountValidateInProgress = (accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_VALIDATE_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountValidateSuccess = (accountId, step) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_VALIDATE_SUCCESS,
    payload: {
        accountId,
        step
    }
});

const requestAccountValidateFailure = (error, accountId, step) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_VALIDATE_FAILURE,
    payload: {
        accountId,
        error,
        step
    }
});

const validateUIStep = (step) => ({
    type: actionTypes.ACCOUNT_DEBITS_EDIT_VALIDATE_STEP,
    payload: {
        step
    }
});

const validateStep = (step) => (dispatch, getState) => {
    dispatch(validateUIStep(step));

    const immAccountDebitsEdit = getState().accountDebitsEdit;
    const originAccountId = immAccountDebitsEdit.get('originAccountId');
    const immFirstStep = immAccountDebitsEdit.getIn(['steps', '0']);
    const newAccountId = immFirstStep.get('newAccount');
    const valid = immFirstStep.get('valid');

    if (valid) {
        const immAccounts = getState().accounts;
        const immNewAccount = immAccounts.getIn(['byId',  newAccountId]);
        const contractNumber = immNewAccount.get('newContractNumber');
        const product = immNewAccount.get('newProduct');
        const immAccount = immAccounts.getIn(['byId', originAccountId]);
        const immIbanComplex = immAccount.get('ibanComplex');
        const codbban = immIbanComplex.get('codbban');
        const controldigit = immIbanComplex.get('digitodecontrol');
        const country = immIbanComplex.get('pais');
        const requestData = {
            query: {
                cccorigen: {
                    codbban: codbban,
                    digitodecontrol: controldigit,
                    pais: country
                },
                entradaSeguridad: {
                    contrato: {
                        numerodecontrato: contractNumber,
                        producto: product
                    }
                }
            }
        };

        dispatch(requestAccountValidateInProgress(originAccountId));
        return APIPost(dispatch, apiURLBuilder.getURL('requestAccountDebitsEditValidation'), requestData)
            .then(() => dispatch(requestAccountValidateSuccess(originAccountId, step)))
            .catch((error) => {
                const message = formatText('accountDebitsEdit-editFailure');
                dispatch(notification.error({message}, {voice: message}));
                dispatch(requestAccountValidateFailure(error, originAccountId, step));
            });
    }
};

const setAccountDebitEdit = (dispatch, data, accountId) => {
    const requestData = {
        query: data
    };

    return APIPost(dispatch, apiURLBuilder.getURL('setAccountDebitsEdit'), requestData)
        .then(() => dispatch(setAccountDebitEditSuccess(accountId)))
        .catch((error) => {
            const message = formatText('accountDebitsEdit-editFailure');

            dispatch(notification.error({message}, {voice: message}));
            dispatch(setAccountDebitEditFailure(error, accountId));
        });
};

const postChange = (accountId, newAccountId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immAccounts = getState().accounts;
        const immAccount = immAccounts.getIn(['byId',  newAccountId]);
        const contractNumber = immAccount.get('newContractNumber');
        const product = immAccount.get('newProduct');
        const immNewAccount = immAccounts.getIn(['byId', accountId]);
        const immIbanComplex = immNewAccount.get('ibanComplex');
        const codbban = immIbanComplex.get('codbban');
        const controldigit = immIbanComplex.get('digitodecontrol');
        const country = immIbanComplex.get('pais');
        const data = {
            contratoLocalOrigen: {
                codbban: codbban,
                digitodecontrol: controldigit,
                pais: country
            },
            dataToken: dataToken,
            entradaSeguridad: {
                contrato: {
                    numerodecontrato: contractNumber,
                    producto: product
                }
            }
        };

        setAccountDebitEdit(dispatch, data, accountId);
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
};

const cancel = () => (dispatch) => {
    const message = formatText('debitsEdit-toasterMessage');
    dispatch(notification.error({message}, {voice: message}));
};

const requestAccountDebitsEditInProgress = (accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountDebitsEditSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_SUCCESS,
    payload: {
        accountDebitsEdit: data.cuentas.cuenta,
        accountId
    }
});

const requestAccountDebitsEditFailure = (error, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_FAILURE,
    payload: {
        accountId,
        error
    }
});

const setOriginAccountId = (accountId) => ({
    type: actionTypes.SET_ORIGIN_ACCOUNT_ID,
    payload: {
        accountId
    }
});

const requestAccountDebitsEdit = (accountId) => (dispatch, getState) => {
    const isAlreadyFetching = getState().accountDebitsEdit.getIn([accountId, 'isFetching']);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const contractNumber = immAccount.get('newContractNumber');
    const product = immAccount.get('newProduct');

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                contrato: {
                    numerodecontrato: contractNumber,
                    producto: product
                }
            }
        };

        dispatch(requestAccountDebitsEditInProgress(accountId));
        return APIPost(dispatch, apiURLBuilder.getURL('requestAccountDebitsEdit'), requestData)
            .then(response => dispatch(requestAccountDebitsEditSuccess(response, accountId)))
            .catch(error => dispatch(requestAccountDebitsEditFailure(error, accountId)));
    }
};

module.exports = {
    cancel,
    postChange,
    reset,
    resetStep,
    requestAccountDebitsEdit,
    setOriginAccountId,
    setAccount,
    setVisibleStep,
    setWillCancel,
    validateStep
};
